import { registerCapability } from '../../platform/capability-registry';
import { RuntimeConfigBlock } from './RuntimeConfigBlock';
import { RUNTIME_CONFIG_FIELD_KEY_LIST } from './fieldKeys';
import { resolveRuntimeConfigPaths } from './resolvePaths';
import type { RuntimeConfigBlockOptions } from './types';

registerCapability<RuntimeConfigBlockOptions>({
  key: 'runtime-config',
  fields: [...RUNTIME_CONFIG_FIELD_KEY_LIST],
  component: RuntimeConfigBlock,
  defaultPaths: (prefix) => resolveRuntimeConfigPaths(prefix),
  resolvePaths: (prefix) => resolveRuntimeConfigPaths(prefix),
});
